var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sprint-1-/-Abgabe",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XLg_Nav-Level1_tooltip",
    transform: "translate(-1275.000000, -63.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1243.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "overlay",
    transform: "translate(0.000000, 4.555556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.852941, 5.857143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9376186,0 L24.5039136,0 C24.2417638,0 24.0294118,0.218544643 24.0294118,0.487973214 L24.0294118,11.2263125 C24.0294118,11.4957411 24.2417638,11.7142857 24.5039136,11.7142857 L30.0762868,11.7142857 L30.0762868,7.32142857 L28.6534926,7.32142857 L28.6534926,5.49107143 L30.0762868,5.49107143 L30.0762868,4.02678571 C30.0762868,2.5138125 31.0071498,1.76922321 32.3186103,1.76922321 C32.9467739,1.76922321 33.4867243,1.81754464 33.643943,1.83877679 L33.643943,3.42020536 L32.7344219,3.42057143 C32.0212463,3.42057143 31.8547794,3.7694375 31.8547794,4.28120536 L31.8547794,5.49107143 L33.6332721,5.49107143 L33.2775735,7.32142857 L31.8547794,7.32142857 L31.8832353,11.7142857 L34.9376186,11.7142857 C35.1994127,11.7142857 35.4117647,11.4957411 35.4117647,11.2263125 L35.4117647,0.487973214 C35.4117647,0.218544643 35.1994127,0 34.9376186,0",
    id: "Fill-3"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.1c4a5eef.svg";
export { ForwardRef as ReactComponent };